module.exports = "/assets/0f828f47164572bf92d8eedaec31617b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZY.png
// module id = 2081
// module chunks = 0